export const splash_screen_page = (t) => ({
	SPLASH_SCREEN_TITLE: {
		value: 'WIN UP TO 50000X',
		config: {
			fill: ['#F00D4B', '#C40035'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 34,
			stroke: '#CFDBB5',
			strokeThickness: 20
		}
	},
	SPLASH_SCREEN_SUBTITLE: {
		value: 'VOLATILITY',
		config: {
			fill: '#F09833',
			fontFamily: 'Poppins SemiBold',
			fontSize: 26
		}
	},
	SPLASH_SCREEN_BTN: {
		value: 'PLAY NOW',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 42
		}
	},
	SPLASH_SCREEN_CHECKBOX: {
		value: t('splashScreen.dont_show_again'),
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	SPLASH_SLIDE_TITLE_1: {
		value: 'PROGRESSIVE BONUS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 42,
			letterSpacing: 1,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ITEM_3_TEXT: {
		value: '+5',
		config: {
			fontFamily: 'Japanese',
			fontSize: 55,
			letterSpacing: 1,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ITEM_3_SUBTEXT: {
		value: 'SPIN',
		config: {
			fontFamily: 'Japanese',
			fontSize: 26,
			letterSpacing: 1,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ITEM_6_TEXT: {
		value: '5X',
		config: {
			fontFamily: 'Japanese',
			fontSize: 55,
			letterSpacing: 1,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ITEM_6_SUBTEXT: {
		value: 'MULT',
		config: {
			fontFamily: 'Japanese',
			fontSize: 32,
			letterSpacing: 1,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	SPLASH_SLIDE_TITLE_2: {
		value: 'CATCH UP TO 5,000X',
		config: {
			fontFamily: 'Japanese',
			fontSize: 42,
			letterSpacing: 1,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	}
});
